/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LockIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LockIcon({
  children,
  viewPath = "/DesignSystem/Svgs/LockIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="LockIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-2kx9LJ': alignSelf,'--mt-2-2kx9LJ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2kx9LJ': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2kx9LJ': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2kx9LJ': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2kx9LJ': opacity,'--w-10-2kx9LJ': typeof width === 'number' ? `${width}px` : width,'--h-11-2kx9LJ': typeof height === 'number' ? `${height}px` : height,'--a-7-2kx9LJ': isAnimated ? animation : "none",'--sd-8-2kx9LJ': isAnimated ? strokeDashoffset : 0,'--sd-9-2kx9LJ': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="LockIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M24.3 29.1H7.7c-1.5 0-2.7-1.2-2.7-2.7v-6.7C5 18.2 6.2 17 7.7 17h16.5c1.5 0 2.7 1.2 2.7 2.7v6.7c.1 1.5-1.1 2.7-2.6 2.7zM8.2 16.9v-6.2c0-4.3 3.5-7.8 7.8-7.8h0c4.3 0 7.8 3.5 7.8 7.8v6.2"
 style={{'--f-12-2kx9LJ': fill,'--s-13-2kx9LJ': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}